import { LeadReportFormData } from '../types/leadReport';

export enum ReportTypeEnum {
  LEADS_OVERVIEW = 'leads-overview',
  AGENT_OVERVIEW = 'agent-overview'
}

export enum JobTypeEnum {
  LEADS_OVERVIEW = 'leads_overview_report_generation',
  AGENT_OVERVIEW = 'agent_overview_report_generation'
}

export enum JobStatusEnum {
  PENDING = 'pending',
  PROCESSING = 'processing',
  SUCCESS = 'success',
  FAILED = 'failed'
}

export const ReportTypeMap = {
  [ReportTypeEnum.LEADS_OVERVIEW]: JobTypeEnum.LEADS_OVERVIEW,
  [ReportTypeEnum.AGENT_OVERVIEW]: JobTypeEnum.AGENT_OVERVIEW
};

export const reportTypeOptions = [
  {
    id: 1,
    label: 'Leads Overview Report',
    value: ReportTypeEnum.LEADS_OVERVIEW
  },
  {
    id: 2,
    label: 'Agent Overview Report',
    value: ReportTypeEnum.AGENT_OVERVIEW
  }
];

export const INITIAL_FORM_DATA: LeadReportFormData = {
  leadCreationDate: '',
  leadCategory: [],
  assignedAgent: [],
  location: [],
  leadStatus: [],
  source: [],
  tags: [],
  addToGroups: [],
  paymentLinkSent: [],
  customDateRange: '',
  leadAssignmentDate: '',
  startDate: '',
  endDate: ''
};
